export const HIRE360 = {
  navy: "#0E2240",
  crimson: "#BB162B",
  gold: "#BF9B30",
  green: "#1B7F3B",
  amber: "#D97706",
  blue: "#1E5AA8",
};

export const ROLES = [
  "SYSTEM_ADMIN", "AMD", "HR_HEAD", "HR_OPERATIONS", "HR_RECRUITER",
  "VERTICAL_HEAD_VP", "ZONAL_HEAD", "BRANCH_HEAD", "BRANCH_DEPT_HEAD",
  "FUNCTIONAL_HEAD", "AUDITOR",
];

export const GRADES = ["L1 VP", "L2 GM-DGM-AGM", "L3 Manager", "L4 Team Leader", "L5 Executive", "L6 Trainee"];
export const OUTLET_FORMATS = ["3S", "2S", "1S", "Workshop", "CPO", "HO"];
export const VERTICALS = ["Sales", "Aftersales", "Support"];
export const EMPLOYMENT_STATUSES = ["Active", "On Notice", "Exited", "Absconded"];
export const HIRE_SOURCES = ["Referral", "Job Portal", "Walk-in", "Consultant", "Campus", "Internal Transfer"];
export const EVENT_TYPES = ["Transfer In", "Promotion", "Resignation", "Exit", "Absconding"];
export const BUSINESS_DRIVERS = ["Growth", "Attrition Backfill", "New Outlet", "Restructure", "Cost Optimisation", "Norm Revision"];
export const STATUS_COLORS = {
  green: "#1B7F3B", amber: "#D97706", red: "#BB162B", blue: "#1E5AA8",
};
